import React, { useState, useEffect } from 'react';
import { Button, Typography } from '@duxton-web/ui';
import {
  colorBrandPrimaryBoldest,
  colorBrandPrimaryBold,
  colorContentSubtle,
  colorOutlineDefault,
} from '@duxton-web/design-tokens/themes/light';

interface Props {
  callback: (isActive: boolean) => void;
  title: string;
  initialState: boolean;
  checked?: boolean; // Add checked prop for controlled component
  width?: string;
  height?: string;
}

const ToggleButton: React.FC<Props> = (props) => {
  const [internalActive, setInternalActive] = useState(props.initialState);

  // Sync internal state when initialState prop changes
  useEffect(() => {
    setInternalActive(props.initialState);
  }, [props.initialState]);

  // Use checked prop if provided (controlled), otherwise use internal state (uncontrolled)
  const isActive = props.checked !== undefined ? props.checked : internalActive;

  const onBtnClick = (): void => {
    const newActiveState = !isActive;

    // Only update internal state if not controlled
    if (props.checked === undefined) {
      setInternalActive(newActiveState);
    }

    props.callback(newActiveState);
  };
  return (
    <Button
      style={{
        width: props.width,
        height: props.height,
        justifyContent: 'center',
        borderWidth: isActive ? 2 : 1,
        fontWeight: isActive ? 600 : 400,
        borderColor: isActive ? colorBrandPrimaryBold : colorOutlineDefault,
      }}
      onClick={onBtnClick}
    >
      <Typography.Body
        level={3}
        style={{
          color: isActive ? colorBrandPrimaryBoldest : colorContentSubtle,
        }}
      >
        {props.title}
      </Typography.Body>
    </Button>
  );
};

export default ToggleButton;
